

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 20 20","fill":"#fff"}, rest), ["\n\n    ", h('path', {"d":"M5.833 8.519v2.962h2.223v5.186h2.963V11.48h2.222l.74-2.962H11.02V7.037c0-.41.331-.74.74-.74h2.222V3.332H11.76c-2.045 0-3.703 1.659-3.703 3.704v1.482H5.833"}, []), "\n"]);
};

        